import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchHistory = ({ history, onSelectHistory, onClearHistory }) => {
  if (history?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 text-center">
        <div className="flex items-center justify-center w-12 h-12 bg-muted rounded-full mx-auto mb-3">
          <Icon name="Clock" size={24} color="var(--color-muted-foreground)" strokeWidth={2} />
        </div>
        <p className="text-sm text-muted-foreground">No recent searches</p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-muted/30 border-b border-border">
        <div className="flex items-center space-x-2">
          <Icon name="History" size={18} color="var(--color-foreground)" strokeWidth={2} />
          <h3 className="text-sm font-semibold text-foreground">Recent Searches</h3>
        </div>
        <Button
          variant="ghost"
          size="xs"
          iconName="Trash2"
          onClick={onClearHistory}
        >
          Clear
        </Button>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto">
        {history?.map((item, index) => (
          <button
            key={index}
            onClick={() => onSelectHistory(item)}
            className="w-full flex items-center justify-between px-4 py-3 hover:bg-muted/50 transition-hover text-left"
          >
            <div className="flex items-center space-x-3 flex-1 min-w-0">
              <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-full flex-shrink-0">
                <Icon name="User" size={16} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{item?.phone}</p>
                <p className="text-xs text-muted-foreground">
                  {new Date(item?.timestamp)?.toLocaleDateString()}
                </p>
              </div>
            </div>
            <Icon name="ChevronRight" size={16} color="var(--color-muted-foreground)" strokeWidth={2} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchHistory;